package com.sweetlime.bingeamigo.repository

import com.sweetlime.bingeamigo.model.LibraryEpisode
import com.sweetlime.bingeamigo.model.LibraryMovie
import com.sweetlime.bingeamigo.model.LibraryTvShow
import com.sweetlime.bingeamigo.model.TvShow
import kotlinx.coroutines.flow.Flow

interface LibraryRepository {

    // --- Movies ---

    fun getWatchlist(): Flow<List<LibraryMovie>>
    fun getWatched(): Flow<List<LibraryMovie>>
    fun getFavorites(): Flow<List<LibraryMovie>>

    suspend fun getUserWatchlist(userId: String): List<LibraryMovie>
    suspend fun getUserWatched(userId: String): List<LibraryMovie>
    suspend fun getUserFavorites(userId: String): List<LibraryMovie>

    suspend fun addToWatchlist(libraryMovie: LibraryMovie)
    suspend fun removeFromWatchlist(movieId: String)

    suspend fun addToWatched(libraryMovie: LibraryMovie)
    suspend fun removeFromWatched(movieId: String)

    suspend fun addToFavorites(libraryMovie: LibraryMovie)
    suspend fun removeFromFavorites(movieId: String)

    // --- TV Shows ---

    fun getTvShowTracking(): Flow<List<LibraryTvShow>>
    fun getTvShowCompleted(): Flow<List<LibraryTvShow>>
    fun getTvShowFavorites(): Flow<List<LibraryTvShow>>

    suspend fun addTvShowToTracking(libraryTvShow: LibraryTvShow)
    suspend fun removeFromTvShowTracking(tvShowId: String)

    suspend fun removeFromTvShowCompleted(tvShowId: String)

    suspend fun addTvShowToFavorites(libraryTvShow: LibraryTvShow)
    suspend fun removeFromTvShowFavorites(tvShowId: String)

    // --- Single-item fetch (for current user) ---

    fun getLibraryMovie(movieId: String): Flow<LibraryMovie?>
    fun getLibraryTvShow(tvShowId: String): Flow<LibraryTvShow?>

    // --- Rating / Review ---

    suspend fun rateMovie(movie: LibraryMovie, rating: Double, review: String?)
    suspend fun rateTvShow(tvShow: LibraryTvShow, rating: Double, review: String?)
    suspend fun rateEpisode(tvShow: LibraryTvShow, episodeId: Int, rating: Double, review: String?)

    // --- Episodes ---

    fun getWatchedEpisodes(tvShowId: String): Flow<List<LibraryEpisode>>
    suspend fun markEpisodeWatched(tvShow: TvShow, episode: LibraryEpisode, totalEpisodesInShow: Int, episodeName: String = "", episodeStillPath: String = "")
    suspend fun markAllSeasonEpisodesWatched(tvShow: TvShow, seasonEpisodes: List<LibraryEpisode>, lastEpisode: LibraryEpisode, totalEpisodesInShow: Int, lastEpisodeName: String = "", lastEpisodeStillPath: String = "")
    suspend fun markEpisodeUnwatched(tvShow: TvShow, episodeId: Int)
}